import { Button, useDndFileUploader } from '@/components';
import { isRS } from '@/utils';
import { PaperClipOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { MAX_FILE_UPLOAD_LENGTH } from '../../constants';
import type { FileEntry } from '../../models/upload';

export const CommentReplyUploadButton: FC<{
  fileEntries: Array<FileEntry>;
  uploadFiles: (acceptedFiles: File[]) => Promise<void>;
  buttonProps: {
    text: string;
    type: 'link' | 'default';
  };
}> = ({ fileEntries, uploadFiles, buttonProps }) => {
  const files = fileEntries.flatMap((entry) =>
    entry.file ? [entry.file] : [],
  );

  const disabled = fileEntries.length >= MAX_FILE_UPLOAD_LENGTH;

  const { openDropzone } = useDndFileUploader({
    files,
    onChange: uploadFiles,
    maxFiles: MAX_FILE_UPLOAD_LENGTH,
    disabled,
    acceptableImage: !isRS(),
    enableMaxFileCountControl: true,
  });

  return (
    <Button
      onClick={openDropzone}
      type={buttonProps.type}
      disabled={disabled}
      icon={<PaperClipOutlined />}
    >
      {buttonProps.text}
    </Button>
  );
};
